export default __webpack_public_path__ + "static/media/icon_answer_drive.7ceb210a.svg";